import type { IContextMutationResult } from '@modules/core/services/query/types';
import {
  AFFILIATES_APPROVED_TRACKERS_LIST_PERMISSIONS,
} from '@modules/affiliates-approved/submodules/trackers-settings/submodules/trackers-list/constants';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import type { IAffiliateCurrentTrackerPayload, IAffiliateCurrentTrackerUpdateResponse } from '../types';
import {
  AFFILIATE_CURRENT_TRACKER_UPDATE_API_URL,
  AFFILIATE_CURRENT_TRACKER_UPDATE_MUTATION,
} from '../constants';

export default function useAffiliateCurrentTrackerUpdateMutation(): IContextMutationResult<
  IAffiliateCurrentTrackerUpdateResponse,
  Error,
  IAffiliateCurrentTrackerPayload
> {
  const { fetchPut } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<IAffiliateCurrentTrackerUpdateResponse, Error, IAffiliateCurrentTrackerPayload>({
    mutationKey: [AFFILIATE_CURRENT_TRACKER_UPDATE_MUTATION],
    mutationFn: ({ id, trackerId, ...tracker }) => fetchPut<IAffiliateCurrentTrackerUpdateResponse>(
      AFFILIATE_CURRENT_TRACKER_UPDATE_API_URL,
      tracker,
      {
        permission: AFFILIATES_APPROVED_TRACKERS_LIST_PERMISSIONS.HISTORY_CHANGES_EDIT,
        urlParams: {
          id,
          trackerId,
        },
      },
    ),
    onSuccess() {
      displayPresetToast('edited');
    },
  });
}
